import React from "react";

import Wrapper from "./wrapper";

const url =
  "https://firebasestorage.googleapis.com/v0/b/collegiate-composites.appspot.com/o/example-photos%2F%%FILE%%.jpg?alt=media";
const example = (file) => url.replace("%%FILE%%", file);

export default ({ onClickNext }) => (
  <Wrapper button="Alright, let's do this!" onClickNext={onClickNext}>
    <div className="grid gap-2 grid-cols-2">
      <img
        src={example("FinishedProduct_Good")}
        alt=""
        className="mx-auto"
        style={{ maxHeight: 280 }}
      />
      <img
        src={example("FinishedProduct_Good2")}
        alt=""
        className="mx-auto"
        style={{ maxHeight: 280 }}
      />
    </div>

    <ul className="mt-6 text-sm leading-6">
      <li className="mb-4 flex">
        <div>✓</div>
        <div className="flex-1 ml-2">
          The finished photo should look as close to this as possible.
        </div>
      </li>
      <li className="mb-4 flex">
        <div>✓</div>
        <div className="flex-1 ml-2">
          Don't worry about the background - our photography gnomes will replace
          it with a background similar to the photos above.
        </div>
      </li>
    </ul>
  </Wrapper>
);
